import { Translation } from 'cng-common/features/translations'
import { ModalDialog } from 'core-components/library/modalDialog'

import type { SobActualsModalProps } from '../model/types'
import { sobActualsModalTranslation } from '../translation'

import {
  SobActualsModalContent,
  type SobActualsModalContentOwnProps,
} from './parts/sobActualsModalContent/SobActualsModalContent'

import styles from './SobActualsModal.module.scss'

export const SobActualsModal = ({
  show,
  pid,
  offering,
  region,
  country,
  partnerName,
  locationId,
  category,
  isBySubCategory,
  isNoPlanEditable,
  defaultMetricMode,
  availableMetricModes,
  currentFiscalYear,
  finData,
  onClose,
  onConfirmed,
}: SobActualsModalProps) => (
  <ModalDialog<SobActualsModalContentOwnProps>
    show={show}
    size="xl"
    classes={{ window: styles.window }}
    header={() => (
      <div className={styles.title}>
        <Translation text={sobActualsModalTranslation.title} span />{' '}
        {category ? <Translation text={category} span /> : '-'}
      </div>
    )}
    closeOnOutsideClick={false}
    content={SobActualsModalContent}
    contentProps={{
      pid,
      offering,
      region,
      country,
      partnerName,
      locationId,
      category,
      isBySubCategory,
      isNoPlanEditable,
      defaultMetricMode,
      availableMetricModes,
      currentFiscalYear,
      finData,
      onConfirmed,
    }}
    onClose={onClose}
  />
)
